export enum EstimateTypes {
    Base = 1,
    Final,
    Alternate
}
